<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <loading-spinner v-if="loading" />

    <template v-else-if="item.id">
      <div class="row justify-content-between px-3 mb-4">
        <img
          src="../assets/images/logo-comune.png"
          style="height:80px"
        >
        <div class="p-5">
          <span
            v-if="item.numeroProtocollo"
            class="protocollo ml-3"
          >
            Prot. n. {{ item.numeroProtocollo }}
          </span>
        </div>
      </div>
      <h2 class="text-center mt-4 text-uppercase">
        COMUNICAZIONE AMPLIAMENTO NUCLEO FAMILIARE
      </h2>

      <!-- da verificare testo seguente -->
      <div class="text-center">
        Dichiarazione sostitutiva resa ai sensi degli artt. 46 e 47 del D.P.R. 445/2000
      </div>

      <h4 class="text-center text-primary mt-3 mb-5 font-weight-bold text-uppercase">
        <span v-if="isOpen">
          Comunicazione da confermare
        </span>
      </h4>
      <b-form inline>
        <p class="text-justify px-4">
          <!-- <pre>{{item}}</pre> -->
          <span>Io sottoscritto/a</span>
          <span class="form-field">{{ item.nome }}</span>
          <span class="form-field">{{ item.cognome }}</span>
          <span>nato/a a</span>
          <span class="form-field">{{ item.comuneNascita }}</span>
          <span>(</span>
          <span class="form-field">{{ item.provinciaNascita }}</span>
          <span>) il</span>
          <span class="form-field">{{ moment(item.dataNascita, 'YYYY-MM-DD', true).isValid() ? moment(item.dataNascita, 'YYYY-MM-DD', true).format('DD/MM/YYYY') : moment(item.dataNascita, 'DD/MM/YYYY', true).format('DD/MM/YYYY') }}</span>
          <span>, codice fiscale</span>
          <span class="form-field">{{ this.$store.state.auth.user.codiceFiscale }}</span>
          <span>, assegnatario dell’alloggio ERP sito in Roma, indirizzo</span>
          <span class="form-field">{{ item.indirizzo }}</span>

          <span>&nbsp;&nbsp;scala&nbsp;</span>
          <span class="form-field">{{ item.scala }}</span>
          <!-- <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.scala"
            type="text"
            :formatter="formatUcase"
            trim
            style="width:5rem"
            placeholder="Scala"
            :state="fieldState('scala')"
            @change="modificaFamiliare"
          />
          <b-form-invalid-feedback v-if="!$v.istanza.scala.required">Campo obbligatorio</b-form-invalid-feedback> -->

          <span>&nbsp;interno &nbsp;</span>
          <!-- <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.interno"
            type="text"
            :formatter="formatUcase"
            trim
            style="width:5rem"
            placeholder="Interno"
            :state="fieldState('interno')"
            @change="modificaFamiliare"
          />
          <b-form-invalid-feedback v-if="!$v.istanza.interno.required">Campo obbligatorio</b-form-invalid-feedback> -->

          <span class="form-field">{{ item.interno }}</span>

        </p>
        <p class="text-justify px-4">
          <span>BU</span>
          <span class="form-field">{{ item.codiceUib }}</span>
          <span>RU</span>
          <span class="form-field">{{ item.codiceUtente }}</span>
        </p>
        <p class="text-justify px-4">
          <span>(D.D. assegnazione n.&nbsp;</span>
          <!--span class="form-field">{{ item.numeroAssegnazione }}</span-->
          <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.numeroAssegnazione"
            type="text"
            :formatter="formatUcase"
            trim
            style="width:8rem"
            placeholder="numero"
            @change="modificaFamiliare"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.istanza.numeroAssegnazione.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <span>&nbsp;del&nbsp;</span>
          <!--span class="form-field">{{ item.dataAssegnazione }}</span-->
          <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.dataAssegnazione"
            type="date"
            :formatter="formatUcase"
            trim
            style="width:11rem"
            placeholder="Data"
            @change="modificaFamiliare"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.istanza.dataAssegnazione.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <span>; contratto di locazione stipulato il&nbsp;</span>
          <!--span class="form-field">{{ item.dataContrattoLocazione }}</span-->
          <b-input
            :disabled="!isOpen"
            class="form-field"
            v-model.trim="item.dataContrattoLocazione"
            type="date"
            :formatter="formatUcase"
            trim
            style="width:11rem"
            placeholder="data"
            @change="modificaFamiliare"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.istanza.dataContrattoLocazione.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <span>), ai sensi dell’articolo 12, comma 5, della legge regionale 12/1999 [1].</span>
        </p>
      </b-form>

      <p class="text-center font-weight-bold my-3 text-uppercase">
        COMUNICO
      </p>

      <p class="text-justify px-4">
        <span>l’ampliamento del nucleo familiare verificatosi in favore di:</span>
      </p>

      <!-- Inserire tabella nuovi componenti nucleo familiare -->

      <div class="ml-4 mb-3">
        <familiari-table
          :item="item"
          @aggiornaFamiglia="modificaFamiliare"
        />
      </div>

      <p class="text-justify px-4">
        Consapevole delle conseguenze amministrative e penali della falsità in dichiarazioni rese in particolare della revoca dei benefici conseguenti al provvedimento emanato sulla base della dichiarazione non veritiera [4], allo scopo, unitamente al sopra indicato componente (solo componente maggiorenne)
      </p>

      <p class="text-center font-weight-bold my-3 text-uppercase">
        Allego ai fini di agevolare l’istruttoria:
      </p>

      <div class="ml-4 mb-3">
        <allegati-table
          :item="allegatiItem"
          :fileAllegati="fileAllegati"
          :isModificato="isModificato"
        />
      </div>

      <p class="small font-italic text-justify mx-4 mb-2">
        <span>I dati acquisiti saranno utilizzati in conformità al nuovo Regolamento Generale sulla Protezione dei Dati Personali (GDPR). Per maggiori dettagli, si prega di consultare la pagina internet: </span>
        <a
          href="https://www.aequaroma.it/societa/privacy-policy.html"
          target="_blank"
        >
          https://www.aequaroma.it/societa/privacy-policy.html
        </a>.
      </p>

      <p
        v-if="item.dataConferma"
        class="text-left mt-5"
      >
        Roma,<span class="form-field">
          {{ moment(item.dataConferma).format('DD/MM/YYYY') }}
        </span>
      </p>

      <div class="row mt-4 mx-2">

        <b-button
          v-if="isOpen"
          variant="success"
          class="m-2"
          @click="doSaveConfirm"
        >
          <font-awesome-icon
            icon="check"
            class="text-white mr-2"
          />Salva e conferma
        </b-button>

        <b-button
          v-if="isOpen"
          variant="primary"
          class="m-2"
          @click="doSaveDraft"
        >
          <font-awesome-icon
            icon="save"
            class="text-white mr-2"
          />Salva in bozza
        </b-button>

        <b-button
          v-if="isOpen && item.stato === 'B'"
          variant="danger"
          class="m-2"
          @click="doDeleteDraftConfirm"
        >
          <font-awesome-icon
            icon="trash-alt"
            class="text-white mr-2"
          />Elimina bozza
        </b-button>

        <a
          v-if="!isOpen && item.stato !== 'P'"
          target="_blank"
          :href="urlIstanza"
        >
          <button class="btn btn-success m-2">
            <font-awesome-icon
              icon="download"
              class="text-white mr-2"
            />Scarica documento
          </button>
        </a>

        <b-button
          variant="outline-secondary"
          class="m-2"
          @click="back"
        >
          <font-awesome-icon
            icon="times"
            class="mr-2"
          />Chiudi
        </b-button>

      </div>
    </template>

    <allegati-standard-modal />

  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import numeral from 'numeral'
import LoadingSpinner from '@/components/LoadingSpinner'
import FamiliariTable from '@/components/FamiliariTable'
import AllegatiTable from '@/components/AllegatiTable'
import AllegatiStandardModal from '@/components/AllegatiStandardModal'

export default {
  components: {
    LoadingSpinner,
    FamiliariTable,
    AllegatiTable,
    AllegatiStandardModal
  },

  data () {
    return {
      loading: true,
      item: {},
      fileAllegati: {},
      message: '',
      isModificato: false
    }
  },

  validations: {
    istanza: {
      scala: { required },
      interno: { required }
      // numeroAssegnazione: { required },
      // dataAssegnazione: { required },
      // dataContrattoLocazione: { required }
    }
  },

  watch: {
    'item.nuoviFamiliari' (newVal) {
      this.item.numeroComponenti = newVal ? newVal.length : 0
    }
  },

  computed: {
    moment () {
      return moment
    },
    numeral () {
      return numeral
    },
    isOpen () {
      return !(this.item.stato === 'V')
    },
    urlIstanza () {
      return `/api/istanze/${this.item.id}/download`
    },
    allegatiItem () {
      return this.item
    }
  },

  async created () {
    await this.load()
  },

  methods: {
    back () {
      this.$router.push({ name: 'istanze' })
    },

    async load () {
      try {
        this.loading = true
        let id = this.$route.params.id
        await this.$store.dispatch('istanze/loadItemById', id)
        let item = this.$store.state.istanze.item
        // console.log('item.numeroProtocollo', item.numeroProtocollo)
        // console.log('item caricato nella load', item)
        if (item.allegati) {
          item.allegati.forEach(x => {
            x.uploaded = ''
          })
        }
        this.item = item
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },
    doSaveConfirm () {
      let allUploaded = !this.item.allegati.some(c => !c.fileName)
      if (!allUploaded) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'Non sono stati caricati tutti i documenti necessari per poter avviare la procedura.'
        })
      } else {
        this.$ui.notify({
          type: 'confirm',
          title: 'Richiesta di conferma',
          message: 'Una volta salvato, il documento non potrà più essere modificato. Confermi il salvataggio del documento?',
          // okHandler: this.doSaveDraft
          okHandler: this.doSave
        })
      }
    },

    async doSave () {
      try {
        let allUploaded = !this.item.allegati.some(c => !c.fileName)
        if (allUploaded) {
          this.loading = true
          // this.item.stato = 'V'
          // this.item.stato = 'B' // -- SOlo per test

          // Salvataggio dei file allegati.
          const formData = new FormData()

          this.item.allegati.filter(f => f.fileName).forEach(f => {
            // console.log('f', f, f.idAllegato, this.fileAllegati)

            formData.set(f.idAllegato, this.fileAllegati[f.idAllegato])
            // f.fileSelected = ''
          })

          formData.set('istanza', JSON.stringify(this.item))
          formData.set('nuovoStato', 'V')

          // console.log('this.fileAllegati', this.fileAllegati)

          await this.$store.dispatch('istanze/save', { id: this.item.id, formData })

          let item = this.$store.state.istanze.item
          item.allegati.forEach(x => {
            x.uploaded = ''
          })

          this.item = item
          this.$ui.notify({
            type: 'success',
            title: 'Esito operazione',
            message: `Operazione eseguita con successo. Il numero di protocollo del documento è: ${this.item.numeroProtocollo}`
          })
          this.back()
        }
      } catch (err) {
        // this.item.stato = 'A'
        this.item.stato = 'B'
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },

    doDeleteDraftConfirm () {
      // console.log('Istanza in bozza da eliminare', this.item)

      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Cancellando la bozza di istanza saranno eliminati tutti gli eventuali allegati caricati, confermi?',
        okHandler: this.doDeleteDraft
      })
    },

    async doSaveDraft () {
      try {
        this.loading = true
        // console.log('Istanza completa da salvare: this.item', this.item)
        // console.log('Istanza completa da salvare: this.allegatiItem', this.allegatiItem)
        // console.log('Istanza completa da salvare: this.fileAllegati', this.fileAllegati)
        // console.log('Istanza completa da salvare: this.item.allegati', this.item.allegati, this.item.allegati ? 'vero' : 'false')

        // Salvataggio dei file allegati.
        const formData = new FormData()

        // if (this.item.allegati) {
        //   this.item.allegati.filter(f => f.fileName).forEach(f => {
        //     // console.log('f', f, f.idAllegato)
        //     if (f.uploaded === 'D' && !f.id) {
        //       // Non serve aggiornare il server.
        //     } else {
        //       formData.set(f.idAllegato, this.fileAllegati[f.idAllegato])
        //     }
        //     // f.fileSelected = ''
        //   })
        // }

        if (this.item.allegati) {
          this.item.allegati.filter(f => f.fileName).forEach(f => {
            // console.log('f', f, f.idAllegato)
            formData.set(f.idAllegato, this.fileAllegati[f.idAllegato])
            // f.fileSelected = ''
          })
        }

        formData.set('istanza', JSON.stringify(this.item))

        // console.log('this.fileAllegati', this.fileAllegati)

        await this.$store.dispatch('istanze/save', { id: this.item.id, formData })

        let item = this.$store.state.istanze.item
        if (this.item.allegati) {
          item.allegati.forEach(x => {
            x.uploaded = ''
          })
        }

        this.isModificato = false
        // console.log('isModificato', this.isModificato)
        this.item = item
        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    async doDeleteDraft () {
      this.loading = true
      try {
        await this.$store.dispatch('istanze/delete', this.item)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
        this.$router.push({ name: 'istanze' })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    fieldState (field) {
      let v = this.$v.istanza[field]
      return v.$dirty && v.$error ? false : null
    },

    formatUcase (value, event) {
      return value.toUpperCase()
    },
    modificaFamiliare () {
      this.isModificato = true
      // console.log('modifica familiare', this.isModificato)
    },
    // ----
    apriForm (idx) {
      this.$refs.allegatiStandardModal.open({ istanza: this.item, idx })
    }

  }
}
</script>
